export const FIELD_LABELS = {
    inspection_date: "Inspection Date",
    inspection_type: "Inspection Type",
    location: "Location",
    precipitation_type: "Precipitation Type",
    precipitation_amount: "Precipitation Amount",
    weather_conditions: "Weather Conditions",
    wind: "Wind",
    temperature_high: "Temperature High",
    temperature_low: "Temperature Low",
};
